import API from "../services/apiservices";

async function getCodigo() {
  await API.getLocalDBDocument("tipospedidoStore").then((doc) => {
    if (doc && doc.data.Success) {
      return doc.data.Data[0].Codigo;
    } else {
      return 0;
     }
  });
}


export default {
  namespaced: true,
  namespace: "tipospedidoStore",

  state: {
    storename: "tipospedidoStore",
    tipospedido: {
      codigo: 'V',
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({name: "tipospedidoStore", route: "Servicos/Tipospedido/Get", setter: "setTipospedido"}),
    gtxTipospedido: (state) => state.tipospedido,
    gtxTipospedido_data: (state) => state.tipospedido.data || [],
    gtxTipospedido_GetById: (state) => (id) => state.tipospedido.data.find(f => f.codigo == id) || {value: 0, text: ""},
    gtxTipospedido_selected: (state, getters) => state.tipospedido.data.find(f => f.codigo == getters.gtxTipospedido_codigo),
    gtxTipospedido_dataoptions: (state) => state.tipospedido.data ? state.tipospedido.data.map(o=>({value: o.codigo, text: o.descricao})).sort((a, b) => a.text.localeCompare(b.text)) : [],
    gtxTipospedido_codigo: (state) => state.tipospedido.codigo,
    gtxTipospedido_descricao: (state, getters) => {
      const data = state.tipospedido.data.find(f => f.Codigo == getters.gtxTipospedido_codigo);
      return data ? data.descricao : "";
    },
    gtxTipospedido_error: (state) => state.tipospedido.error,
  },

  mutations: {
    setTipospedido: (state, Tipospedido) => (state.tipospedido = {api: Tipospedido.apiresponse, data: Tipospedido.data, codigo: Tipospedido.data[0].Codigo, error: null}),
    setTipospedidocodigo: (state, codigo) => (state.tipospedido.codigo = codigo),
    setTipospedidodata: (state, data) => (state.tipospedido.data = data),
  },

  actions: {
    actTipospedidoGet({ commit, getters }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "tipospedidoStore", route: "Servicos/Tipospedido/Get", setter: "setTipospedido"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", {StoreName: getters.gtxStore.name}, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  res(data);
                }).catch((error) => {
                  // Tenta retornar dados do IndexDB em caso de erro
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      res(doc.data);
                    } else {
                      // Se não houver dados no IndexDB, retorna estrutura vazia
                      const emptyData = { data: [], codigo: 'V', error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
            });
          }).catch((error) => {
            // Fallback para IndexDB
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc && doc.data) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                const emptyData = { data: [], codigo: 'V', error: error.message };
                res(emptyData);
              }
            });
          });
        } catch (err) {
          rej(err);
        }
      });

    },
    actTipospedidoMudaEmpresa({ commit, getters }, codigo) {
      const data = getters.gtxTipospedido_data.find(f => f.Codigo == codigo);
      if (data) {
        commit("setTipospedidocodigo", data.Codigo);
      }
    }
  },
};
